export type ReportIssueContactFlags = {
    firstName: boolean;
    lastName: boolean;
    email: boolean;
    phone: boolean;
};

export type ReportIssueContactInput = {
    isRequiredFieldsEnabled: boolean;
    preferredContact: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
};

export type ReportIssueContactValidation = {
    required: ReportIssueContactFlags;
    missing: ReportIssueContactFlags;
    isValid: boolean;
};

export const validateReportIssueContact = ({
    isRequiredFieldsEnabled,
    preferredContact,
    firstName,
    lastName,
    email,
    phone
}: ReportIssueContactInput): ReportIssueContactValidation => {
    const required: ReportIssueContactFlags = {
        firstName: isRequiredFieldsEnabled,
        lastName: isRequiredFieldsEnabled,
        email: isRequiredFieldsEnabled && preferredContact === 'Email',
        phone: isRequiredFieldsEnabled && preferredContact === 'Phone'
    };

    const missing: ReportIssueContactFlags = {
        firstName: required.firstName && firstName.trim() === '',
        lastName: required.lastName && lastName.trim() === '',
        email: required.email && email.trim() === '',
        phone: required.phone && phone.trim() === ''
    };

    return {
        required,
        missing,
        isValid: !missing.firstName && !missing.lastName && !missing.email && !missing.phone
    };
};
